import React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M17.75 7L14 3.25l-10 10V17h3.75l10-10zm2.96-2.96c.39-.39.39-1.02 0-1.41L18.37.29a.9959.9959 0 0 0-1.41 0L15 2.25 18.75 6l1.96-1.96z"
}), /*#__PURE__*/React.createElement("path", {
  fillOpacity: ".36",
  d: "M0 20h24v4H0z"
})), 'BorderColor');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/BorderColor.js
// module id = 2423
// module chunks = 2